// src/component/Home.js
import React, { useState, useEffect, useRef, useCallback } from 'react';
import PageTitle from './includes/PageTitle';
import { Link, useParams } from 'react-router-dom';
import Loader from './Loader'; // Import the Loader component
import Footer from './includes/Footer';
import './css/Home.css'
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import shirt1 from './images/shirt1.jpg'; // Correctly import the image
import shirt2 from './images/shirt2.jpg'; // Correctly import the image


import relImage from './images/shirt1.jpg';

// import required modules
import { Pagination, Navigation } from 'swiper/modules';
import NewArrivals from './includes/NewArrivals';
import BestSelling from './includes/BestSelling';


export default function Home() {

  const bestSellingRef = useRef(null);

 // Handle functions for Best Selling slider
 const handlePrevBestSelling = useCallback(() => {
   if (!bestSellingRef.current) return;
   bestSellingRef.current.swiper.slidePrev();
 }, []);

 const handleNextBestSelling = useCallback(() => {
   if (!bestSellingRef.current) return;
   bestSellingRef.current.swiper.slideNext();
 }, []);

 
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 4000); // Loader lasts for 5 seconds

    return () => clearTimeout(timer);
  }, []);

  

  return (
    <div>
      <PageTitle title="Home - ALMOSTINVISIBLE" />
      {loading && <Loader />} {/* Replace with your image path */}
      {!loading && (
        <>
          
          {/* Your home page content */}
          
          <div style={{marginTop: "-8vh"}}>
            <main>
              <div className="intro">
                <div className="wrapper">
                  <div className="intro-content d-flex justify-content-center text-center">
                    <div className='fw-bold d-flex align-items-center intro-statement'>
                      
                      <span className='red-bordered-bottom unbounded'>ALMOSTINVISIBLE</span> &nbsp;
                  
                      <span className='unbounded'> IS PEAK</span>
                    </div>
                    <Link to="/all-products" className="white-button mx-auto">
                      Shop Now
                    </Link>
                  </div>
                </div>
              </div>
              <div className="p-grid">
                
                  
                  <div className="intro-clothes-box">
                    <div className="wrapper" style={{ marginRight: "-1vw" }}>
                      <div className='text-center'>
                        <p className='unbounded fw-bold d-flex h3 intro-statement my-3' style={{color: "white"}}>WEARS</p>
                        <Link href="/products/WEARS" className="white-button">
                          Shop Now
                        </Link>
                      </div>
                    </div>
                  </div>
                  
                  <div className="intro-bag-box">
                    <div className="wrapper" style={{ marginLeft: "-1vw" }}>
                      <div>
                      <p className='unbounded fw-bold d-flex h3 intro-statement my-3' style={{color: "white"}}>COSMETICS</p>
                        <Link to="/products/COSMETICS" className="white-button">
                          Shop Now
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="intro-almostonpanache-box">
                    <div className="wrapper" style={{ marginLeft: "-1vw" }}>
                      <div>
                      <p className='unbounded fw-bold d-flex h3 intro-statement my-3' style={{color: "white"}} >ALMOSTONPANACHE</p>
                        <Link to="/products/UNRELEASED" className="white-button">
                          Shop Now
                        </Link>
                      </div>
                    </div>
                  </div>


              


                <NewArrivals />

                <BestSelling />
              
               
                


                <div className="col-12 intro-shades-box">
                  <div className="wrapper">
                    <div>
                    <p className='unbounded fw-bold d-flex h3 intro-statement my-3' style={{color: "white"}}>ART BY TBX</p>
                      <a href="/products/ART BY TBX" className="white-button">
                        Shop Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
          


          <Footer />
        </>
      )}
    </div>
  );
}
